unit DeviceItemType;
{

  /* Initial. */

}
interface

type
  TDeviceItemType = class
  private
    fDeviceKey: String;
    fName: String;
    fDeviceType: String;
    fActive: Boolean;
  published
    property DeviceKey: String read fDeviceKey;
    property Name: String read fName;
    property DeviceType: String read fDeviceType;
    property Active: Boolean read fActive;
  end;

implementation

end.
